<template>
  <footer>
    <h2>Stories</h2>
    <nav>
      <router-link :to="'/norway'"><span>Culture</span><em>In Norway,</em> educators, politicians, parents and students are finding ways to incorporate traditional practices into the school system.</router-link>
      <router-link :to="'/nepal'"><span>Language</span><em>In Nepal,</em> educators are on the frontlines of the effort to preserve the country’s nearly 131 mother tongue languages.</router-link>
      <router-link :to="'/kenya'"><span>Inclusion</span><em>In Kenya,</em> a new curriculum promises to focus on the needs of individual students, including those with disabilities.</router-link>
      <router-link :to="'/pakistan'"><span>Religion</span><em>In Pakistan,</em> a new curriculum aims to pull religious madrassas into the mainstream school system.</router-link>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'StoryNavigation',
  data () {
    return {
      menuActive: false
    }
  }
}
</script>

<style lang="scss">

footer {
  background-color: darken($white, 2%);
  padding: 2rem;
  h2 {
    padding: 0;
    margin: 0;
    font-size: 2.2em;
      @include md {
        padding: 0 1rem;
      }
  }
  nav {
    a {
      padding: 0.3rem 0;
      text-decoration: none;
      font-size: 0.8em;
      display: block;
      margin: 1rem 0;
      color: $black;
      @include inset-focus-shadow;

      span {
        font-weight: 700;
        display: block;
        font-size: 1.4em;
        margin-bottom: 0.3rem;
      }
    }
    @include md {
      display: flex;
        a {
          padding: 1rem;
          opacity: 0.7;
          transition: opacity 0.4s;
          flex: 1 1 0;
          margin: 0;
          border-size: 1px;

          &:hover, &:focus, &.router-link-active {
            opacity: 1;
          }
        }
    }
    @include lg {
      a {
        padding: 1rem 2.5rem 1rem 1rem;
      }
    }
  }
}
</style>